import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DownloadService } from '../../services';

@Pipe({
  name: 'isInDownload'
})
export class IsInDownloadPipe implements PipeTransform {
  constructor(private downloadService: DownloadService) {}

  transform(value: number): Observable<boolean> {
    return this.downloadService.isInDownload.pipe(map((ids: number[]) => ids.some((id) => id === value)));
  }
}
